import { Card } from '@axo/ui-core/components/Card';
import { Heading, Text } from '@axo/ui-core/components/typography';
import { clsx } from 'clsx';
import { CSSProperties, ReactElement } from 'react';

import styles from './progressTag.module.scss';

export type ProgressTagProps = {
  /** progress as percentage */
  progress: number;
  labels: {
    /** use i18n string interpolation, add `{{progress}}` in the string */
    title: string;
    description: string;
  };
  className?: string;
} & HTMLDataAttributes;

/**
 * ProgressTag component
 */
export const ProgressTag = ({
  progress,
  labels,
  className,
  ...props
}: ProgressTagProps): ReactElement => {
  const _progress = Math.min(100, Math.max(0, progress));

  return (
    <Card
      spacing={'small'}
      className={clsx(styles.progressTag, className)}
      style={{ '--progress': _progress } as CSSProperties}
      {...props}
    >
      <Heading size={'s'}>
        {labels.title.replace('{{progress}}', _progress as unknown as string)}
      </Heading>
      <Text size={'l'}>{labels.description}</Text>
    </Card>
  );
};
